<template>
  <router-view v-model="focusPoint" />
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useFetchQuery } from '@hooks/fetch';
import { syncHeader } from '@components/structure/navigation/injects';
import { syncPageBusy } from '@utils/busy/injects';
import type { Campaign, FocusPoint } from '@/entities/Entities';

interface Props {
  modelValue: Campaign | null;
}

const props = defineProps<Props>();

const route = useRoute();
const { data: focusPoint, loading } = useFetchQuery<FocusPoint>(
  `/focus_points/${route.params.focusPointId}`,
);

syncPageBusy(loading);

const title = computed(() => focusPoint.value?.name);

syncHeader(
  focusPoint,
  (newFocusPoint) => ({
    extraBreadcrumbs: [
      computed(() => ({
        label: title.value ?? '',
        link: { name: 'campaign-group-focus-point-details', params: { campaignGroupId: focusPoint.value?.campaign?.group?.id, focusPointId: focusPoint.value?.id } },
      })),
    ],
    title: computed(() => ({
      text: title.value ?? '',
      link: { name: 'campaign-group-focus-points', params: { campaignGroupId: focusPoint.value?.campaign?.group?.id } },
    })),
  }),
);
</script>

<style lang="scss" scoped></style>
